import { render, staticRenderFns } from "./list-point-detail.vue?vue&type=template&id=a65217d6"
import script from "./list-point-detail.vue?vue&type=script&lang=js"
export * from "./list-point-detail.vue?vue&type=script&lang=js"
import style0 from "./list-point-detail.vue?vue&type=style&index=0&id=a65217d6&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports